module.exports = __webpack_public_path__ + "static/img/longHairEffects.1db1830.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/longHairEffects.gif
// module id = 46rJ
// module chunks = 1